// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.accounting.TransferInvoiceBalanceToPatientRequest */
/* istanbul ignore next */
@GandalfModel
export class TransferInvoiceBalanceToPatientRequest extends GandalfModelBase {

	@GandalfLabel('Invoice')
	@GandalfValidator({ notNull: { message: 'Invoice is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	invoiceId!: number;

	@GandalfLabel('Comments')
	@GandalfValidator({ sizeString: { min: 1, max: 187, message: 'Comments must be between 1 and 187 characters' } })
	@GandalfValidator({ notNull: { message: 'Comments are required' } })
	@GandalfProperty({ designType: String, isRequired: true })
	reason!: string;

}
